export const ARCS_MOBILE = [
    'M79.5576 132.953C79.5576 120.372 84.0045 108.195 92.1126 98.5754C100.221 88.9555 111.468 82.511 123.867 80.3807C136.267 78.2503 149.02 80.5712 159.874 86.9333C170.728 93.2953 178.984 103.289 183.183 115.149C187.382 127.008 187.255 139.97 182.822 151.745C178.39 163.519 169.939 173.348 158.961 179.495C147.984 185.642 135.187 187.711 122.832 185.336C110.477 182.962 99.3591 176.297 91.4424 166.519',
    'M56.0891 132.936C56.0891 119.595 59.5637 106.484 66.1708 94.8945C72.7778 83.3047 82.2895 73.6354 93.7692 66.8389C105.249 60.0423 118.301 56.3528 131.64 56.1336C144.979 55.9144 158.145 59.1731 169.842 65.5889C181.539 72.0046 191.363 81.3561 198.347 92.7227C205.332 104.089 209.235 117.079 209.673 130.412C210.112 143.746 207.07 156.964 200.847 168.765C194.624 180.565 185.435 190.542 174.185 197.712',
    'M33.2602 132.921C33.2602 119.016 36.1705 105.264 41.804 92.5516C47.4375 79.8387 55.6695 68.4456 65.9704 59.1052C76.2713 49.7647 88.4132 42.6836 101.615 38.3173C114.817 33.951 128.786 32.3962 142.625 33.7529C156.464 35.1095 169.866 39.3476 181.968 46.1946C194.071 53.0415 204.606 62.3458 212.897 73.5088C221.188 84.6719 227.051 97.4467 230.108 111.012C233.166 124.576 233.35 138.631 230.65 152.271',
    'M10.2167 132.904C10.2167 107.16 18.3153 82.0676 33.3656 61.1807C48.416 40.2937 69.6555 24.6705 94.0768 16.523C118.498 8.3756 144.863 8.11691 169.44 15.7836C194.016 23.4502 215.558 38.6537 231.016 59.2413',
];

export const ARCS_DESKTOP = [
    'M97.3358 162.655C97.3358 147.263 102.776 132.367 112.696 120.598C122.615 108.829 136.375 100.944 151.545 98.3382C166.714 95.7319 182.317 98.5713 195.596 106.355C208.874 114.138 218.975 126.364 224.112 140.873C229.249 155.383 229.093 171.241 223.67 185.645C218.248 200.05 207.908 212.075 194.479 219.595C181.049 227.115 165.393 229.646 150.278 226.741C135.163 223.836 121.561 215.682 111.876 203.72',
    'M68.622 162.636C68.622 146.315 72.8729 130.275 80.9559 116.096C89.039 101.917 100.676 90.0871 114.72 81.7722C128.764 73.4572 144.732 68.9434 161.051 68.6753C177.37 68.4071 193.478 72.3939 207.788 80.2429C222.098 88.0919 234.117 99.5326 242.661 113.439C251.206 127.344 255.981 143.236 256.518 159.548C257.054 175.861 253.332 192.032 245.719 206.469C238.107 220.906 226.865 233.111 213.101 241.883',
    'M40.6918 162.617C40.6918 145.606 44.2524 128.782 51.1444 113.229C58.0365 97.6764 68.1075 83.7381 80.7096 72.3109C93.3118 60.8838 108.166 52.2207 124.317 46.879C140.469 41.5373 157.559 39.6351 174.49 41.2948C191.42 42.9546 207.816 48.1395 222.622 56.5161C237.428 64.8927 250.318 76.2755 260.461 89.9325C270.604 103.589 277.776 119.218 281.517 135.813C285.257 152.409 285.483 169.603 282.179 186.291',
    'M12.5 162.596C12.5 131.1 22.4078 100.402 40.8205 74.8487C59.2332 49.2955 85.2177 30.182 115.095 20.2144C144.972 10.2468 177.227 9.93031 207.294 19.3097C237.361 28.6891 263.716 47.2891 282.626 72.4761',
];

export const CHART_CONFIG = {
    mobile: {
        viewBox: '0 0 243 207',
        arcs: ARCS_MOBILE,
        strokeWidth: 20,
        svgWidth: 245,
        wrapperWidth: 343,
        height: 290,
    },
    desktop: {
        viewBox: '0 0 297 253',
        arcs: ARCS_DESKTOP,
        strokeWidth: 25,
        svgWidth: 300,
        wrapperWidth: 343,
        height: 350,
    },
};

export const LABEL_LAYOUT = {
    mobile: {
        baseGap: 15,
        collisionPadding: 4,
        arcPadding: 3,
        overflow: { left: 8, right: 70, top: 10, bottom: 0 },
        stepX: 3,
        stepY: 3,
        fallbackWidth: 70,
        fallbackHeight: 30,
        maxSteps: 90,
    },
    desktop: {
        baseGap: 25,
        collisionPadding: 6,
        arcPadding: 4,
        overflow: { left: 15, right: 130, top: 15, bottom: 0 },
        stepX: 3,
        stepY: 3,
        fallbackWidth: 90,
        fallbackHeight: 34,
        maxSteps: 90,
    },
};
